import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";

import { useFormik, useFormikContext } from "formik";
import toast from "react-hot-toast";

//import { FaRegCircleXmark, FaPercent } from "react-icons/fa6";
import * as SVGImages from "../../svg";
import { IoMdClose } from "react-icons/io";

import "../Asociados/createAsociados.css";
import "./createOrden.css";
import { createOrdenFormValidation } from "../../../../helper/validate";

import * as api from "helper/helper";
import "./../formsCommons.css";

//import styles from "./../tooltip.module.css";
//import createOrdenStyles from "./createOrden.module.css";

import { EstadoBodega } from "../../../../helper/const";
import { buildNameWithId, Singleton } from "helper/tools";
import invalidClass, {
  FORMA_DE_PAGOS,
  METODO_DE_PAGOS,
  ORDEN_VENTA_STATUS,
  PROMOCIONES_STATES,
} from "../../helperFunctions/helpers";
import LoadingButton from "../LoadingButton/LoadingButton";
import AutocompleteGo from "../Autocomplete/AutocompleteGo";
import CreateClient from "../Clientes/CreateClient";
import { PermissionsForSection } from "../auth";
import { Sections } from "../../data/navItem";
import { useTimeout } from "../../hooks/useTimeout";
import SelectBonificacion from "./SelectBonificacion";
import ErrorModal from "./ErrorModal";
import ProductoCard from "./ProductoCard";
import PaqueteCard from "./PaqueteCard";
import { useUpdateEffect } from "../../../../hooks/useUpdateEffect";

const CreateOrdenVenta = forwardRef(({ item, reloadOrdenes }, ref) => {
  const modalRef = useRef();
  const buttonCancelModalRef = useRef();
  const asociadoIdRef = useRef(0);

  const createClientesRef = useRef();
  const selectBonificacionRef = useRef();
  const errorModalRef = useRef();
  const errorModalBonificacionesRef = useRef();
  const [modalDataBonificacion, setModalDataBonificacion] = useState(null);

  const refAutocompleteAsociados = useRef(null);
  const refAutocompleteProducto = useRef(null);

  const dropDownClientesRef = useRef();

  /// CHECAR  useTraceUpdate(props, "CreateOrdenVenta");
  const [isActiveDisabled, setIsActiveDisabled] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [asociados, setAsociados] = useState([]);
  const [formasDePago, setFormasDePago] = useState([]);
  const [metodosDePago, setMetodosDePago] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [productos, setProductos] = useState([]);
  const [modalData, setModalData] = useState(null);
  const [defaultOnlyAsociadoId, setDefaultOnlyAsociadoId] = useState();
  const [disableCrearOrden, setDisableCrearOrden] = useState(true);
  const [disableSeleccionarCantidad, setDisableSeleccionarCantidad] =
    useState(true);
  const [disableAgregarProducto, setDisableAgregarProducto] = useState(true);
  const [hasBonificaciones, setHasBonificaciones] = useState(true);

  const [roles, setRoles] = useState([]);
  const [ordenSubtotal, setOrdenSubtotal] = useState(0);
  const [ordenDescuento, setOrdenDescuento] = useState(0);

  const [errorCantidad, setErrorCantidad] = useState("");

  const [asociadoConNombre, setAsociadoConNombre] = useState([]);
  const [asociadoConCURP, setAsociadoConCURP] = useState([]);
  const [asociadoConCURPEnOtro, setAsociadoConCURPEnOtro] = useState([]);

  const [ordenTotal, setOrdenTotal] = useState(0);
  const [productosAgregados, setProductosAgregados] = useState([]);

  const [creditoSuperado, setCreditoSuperado] = useState(false);
  const [asociadoCongelado, setAsociadoCongelado] = useState(false);
  const [ordenBlocked, setOrdenBlocked] = useState(false);

  const [showClientesConCurp, setShowClientesConCurp] = useState(true);
  const [showClientesConNombre, setShowClientesConNombre] = useState(true);
  const [showClientesConCurpEnOtro, setShowClientesConCurpEnOtro] =
    useState(true);

  const { clearTimers, addAlert } = useTimeout();

  const [permissions, setPermissions] = useState({
    canCreate: true,
    canEdit: true,
    canVerDetalle: true,
  });

  const [searchTerm, setSearchTerm] = useState("");

  const [showClearButton, setShowClearButton] = useState(false);

  const [asociadoSelected, setAsociadoSelected] = useState(false);

  const createMode = item == null || (item && Object.keys(item).length === 0);

  useEffect(() => {
    console.log("---> change item: " + item);
    let isActiveDisable = createMode;
    setIsActiveDisabled(isActiveDisable);

    setProductosAgregados([]);
    setProductos([]);

    setOrdenSubtotal(0);
    setOrdenTotal(0);
    setOrdenDescuento(0);

    setAsociadoConNombre([]);
    setAsociadoConCURP([]);
    setAsociadoConCURPEnOtro([]);

    refAutocompleteProducto.current.clearInput();

    if (item == null) {
      return;
    }

    formik?.resetForm();

    loadItem(item);
  }, [item]);

  useEffect(() => {
    // 1. Skip the initial empty render or short terms
    if (!searchTerm.trim()) {
      setAsociadoConNombre([]);
      setAsociadoConCURP([]);
      setAsociadoConCURPEnOtro([]);

      setShowClearButton(false);
      return;
    }

    setShowClearButton(true);

    // 2. Set a timer to execute the search after 500ms
    const delayTimer = setTimeout(async () => {
      console.log(`Fetching API data for: ${searchTerm}`);
      // Replace with your actual API call, e.g., fetch(`/api/search?q=${searchTerm}`)

      const response = await api
        .searchFastClientes({
          asociadoId: formik.values.asociadoId,
          texto: searchTerm,
          isActivo: true,
          page: 1,
          pageSize: "350",
        })
        .catch((e) => {
          toast.error("Error al pedir clientes.");
        });

      if (!response) {
        setAsociadoConNombre([]);
        setAsociadoConCURP([]);
        setAsociadoConCURPEnOtro([]);
        //setShowClearButton(false);

        return;
      }

      const data = response.data;

      setAsociadoConNombre(data.clientes.subset);

      const difAsociado = data.infosCurp.find((e) => e.mismoAsociado === false);
      const mismoAsociado = data.infosCurp.find(
        (e) => e.mismoAsociado === true,
      );
      setAsociadoConCURP(mismoAsociado?.infos ?? []);
      setAsociadoConCURPEnOtro(difAsociado?.infos ?? []);

      console.log(response);
    }, 1000);

    // 3. Cleanup: Clears the timer if the user types another character before 500ms passes
    return () => clearTimeout(delayTimer);
  }, [searchTerm]);

  const fetchData = async () => {
    /*const response = await api.asociados().catch((e) => {
      toast.error("Error al pedir asociados.");
    });*/
    const response = await api
      .searchAsociados({ isActivo: true, page: 1, pageSize: "350" })
      .catch((e) => {
        toast.error("Error al pedir asociados.");
      });
    if (!response) return;

    /*pagingInfoRef.current.updatePageNumber(newPageNumber);
    
        setPageButtons(rangePage);
    
        setResponsePagingInfo({
          count,
          isFirstPage,
          isLastPage,
          pageNumber: newPageNumber,
          totalPages,
        });*/

    //setAsociados(response.data.subset);
    //  store.updateAsociados(response.data.subset);
    //  setAsociados(response.data.subset);

    ///

    const autoAsociados = response.data.subset.map((item) => {
      const text = buildNameWithId(item, item.numAsociado);
      return { id: item.id, nombre: text, info: item };
    });

    setAsociados(autoAsociados);

    api
      .tiposEntrega()
      .then((response) => {
        setRoles([...response.data]);

        console.log(response.status);
      })
      .catch((e) => {
        console.log(e); // "oh, no!"
      });

    console.log(response.status);

    // Forma de Pago
    const responseFormaPago = await api.formasDePago().catch((e) => {
      toast.error("Error al pedir asociados.");
    });
    if (!responseFormaPago) return;

    const autoFormaPago = responseFormaPago.data.map((item) => {
      const text = buildNameWithId(item, item.numAsociado);
      return { id: item.id, nombre: text, info: item };
    });

    setFormasDePago(autoFormaPago);

    //Metodos de PAgo
    const responseMetodosPago = await api.metodosDePago().catch((e) => {
      toast.error("Error al pedir asociados.");
    });
    if (!responseMetodosPago) return;

    const autoMetodosPago = responseMetodosPago.data.map((item) => {
      const text = buildNameWithId(item, item.numAsociado);
      return { id: item.id, nombre: text, info: item };
    });

    setMetodosDePago(autoMetodosPago);
  };

  const searchFetchData = async (text) => {
    const criteria = {
      isActivo: true,
      texto: text,
      page: 1,
      pageSize: 25,
    };

    const responseProductos = await api.searchProductos(criteria).catch((e) => {
      toast.error("Error al pedir producto.");
    });
    if (!responseProductos) return;

    const searchPaqueteCriteria = { nombre: text, page: 1, pageSize: 25 };
    const responsePaquetes = await api
      .searchPaquetes(searchPaqueteCriteria)
      .catch((e) => {
        toast.error("Error al pedir producto.");
      });
    if (!responseProductos) return;

    const prods = responseProductos.data.subset.map((item) => {
      return { ...item, kind: "prod" };
    });
    const paqs = responsePaquetes.data.subset.map((item) => {
      return { ...item, kind: "paq", cantidad: 10 };
    });

    const all = [...prods, ...paqs];

    setProductos(all);
  };

  useEffect(() => {
    formik?.resetForm();

    fetchData();

    const newPermissions = PermissionsForSection(Sections.Clientes);
    setPermissions(newPermissions);
  }, []);

  useEffect(() => {
    formik.setFieldValue("asociadoId", formik.values.asociadoId);
  }, [asociados]);

  let initialValues = {
    id: 0,

    apartado: false,

    clienteId: null,
    asociadoId: 0,
    tipoEntregaId: 1,
    metodoDePagoId: METODO_DE_PAGOS.PLAZOS_QUINCENALES_ID,
    formaDePagoId: preloadFormaPago(METODO_DE_PAGOS.PLAZOS_QUINCENALES_ID),
    asociadoNombreCurp: "",

    subTotalVenta: 0,
    descuento: 0,
    totalVenta: 0,
    ordenVentaDetalles: [],

    cantidad: 0,
    productoDisponible: 0,
  };

  if (!createMode) {
    initialValues = {
      id: item.id,

      clienteId: item.cliente?.id,
      asociadoId: item.asociado.id,
      tipoEntregaId: item.tipoEntrega.id,
      metodoDePagoId: item.metodoDePago?.id,
      formaDePagoId: item.formaDePago?.id,
      subTotalVenta: item.subTotalVenta,
      descuento: item.descuento,
      totalVenta: item.totalVenta,
      ordenVentaDetalles: item.ordenVentaDetalles,

      apartado: item.estadoBodega.id === EstadoBodega.Apartado,
    };
  }

  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    validate: createOrdenFormValidation,
    validateOnBlur: false,
    validateOnChange: false,
    onSubmit: async (values, { props, setSubmitting }) => {
      if (values.clienteId === 0) values.clienteId = null;

      /*
    > ignorar el minimo de 200 para la orden de compra 
- si alguno de los productos tiene una bonificacion de regalo
*/
      const bonificacionesRegalo = productosAgregados.find((item) => {
        if (item.bonificaciones == null || item.bonificaciones?.length === 0)
          return false;
        const promocion = item.bonificaciones[0].promocion;
        return promocion.id === PROMOCIONES_STATES.REGALO_EN_COMPRA.id;
      });
      //--
      if (bonificacionesRegalo == null && ordenTotal < 20) {
        errorModalRef.current.toggleModal();
        return;
      }

      // normalize
      const ordenVentaDetalles = productosAgregados.map((item) => {
        //-
        let descuentoPorcentaje = 0;
        let promocionId = item.promocionId;
        if (item.bonificaciones?.length > 0) {
          const bonificacion = item.bonificaciones[0];
          const { promocion, promoConfig } = bonificacion;

          /**
           * VEnta Interna aplicar descuentoProducto de la pantalla por el personalizado del %
           */
          //if (promocion.id === PROMOCIONES_STATES.VENTA_INTERNA.id) {
          if (promocion.editar) {
            descuentoPorcentaje = promoConfig.descuentoPorcentaje;
          }
        }
        //-
        let endItem = {
          ordenVentaId: 0,
          productoId: item.id,
          cantidad: item.cantidad,
          precio: item.precio,
          total: item.total,
          subTotal: item.subTotal,
          descuento: item.descuento,
          promocionId: promocionId,
          descuentoPorcentaje: descuentoPorcentaje,
        };

        if (item.kind === "paq") {
          delete endItem.productoId;
          endItem.paqueteId = item.id;
        }
        return endItem;
      });

      values.totalVenta = ordenTotal;
      values.subTotalVenta = ordenSubtotal;
      values.descuento = ordenDescuento;

      values.ordenVentaDetalles = ordenVentaDetalles;

      /* default es En proceso Id = 1
      apartado = 2
      */
      const estadoBodegaId = formik.values.apartado
        ? EstadoBodega.Apartado
        : EstadoBodega.EnProceso;
      values.estadoBodegaId = estadoBodegaId;

      if (values.id === 0) {
        setIsLoading(true);
        const toastId = toast.loading("Creando Orden de Venta...");
        let response = await api.createOrdenVenta(values).catch((e) => {
          toast.dismiss(toastId);
          if (e.esError && e.codigoError && e.mensaje) {
            toast.error(`Error al Orden de Venta. ${e.mensaje}`);
            setIsLoading(false);
            return;
          }
          toast.error("Error al Orden de Venta.");
          setIsLoading(false);
        });

        setIsLoading(false);
        toast.dismiss(toastId);

        if (!response) return;

        toast.success("Orden de Venta creado.");
        reloadOrdenes();

        buttonCancelModalRef.current.click();
      } else {
        const toastId = toast.loading("Actualizando Orden...");
        setIsLoading(true);
        const response = await api.updateOrdenesVentas(values).catch((e) => {
          setIsLoading(false);
          toast.dismiss(toastId);
          toast.error("Error al actualizar Orden.");
        });
        if (!response) return;

        toast.dismiss(toastId);
        setIsLoading(false);

        toast.success("Orden actualizado.");
        reloadOrdenes();

        buttonCancelModalRef.current.click();
      }
    },
  });

  useEffect(() => {
    setShowClearButton(formik.values.asociadoNombreCurp?.length > 0);
  }, [formik.values.asociadoNombreCurp]);

  React.useEffect(
    (e) => {
      // Submit the form imperatively as an effect as soon as form values.token are 6 digits long
      /*if (values.token.length === 6) {
       submitForm();
     }*/
      //  formik.validateForm();
      console.log("-->>> asociadoId");
      if (formik.values.asociadoId > 0) {
        formik.validateForm();
        invalidateBonificacion();
      }
    },
    [formik.values.asociadoId],
  );

  React.useEffect(
    (e) => {
      // Submit the form imperatively as an effect as soon as form values.token are 6 digits long
      /*if (values.token.length === 6) {
       submitForm();
     }*/
      //  formik.validateForm();
      console.log("-->>> clienteId");
      if (formik.values.clienteId > 0) {
        formik.validateForm();
        invalidateBonificacion();
      }
    },
    [formik.values.clienteId],
  );

  const { asociadoId, metodoDePagoId } = formik.values;

  useEffect(() => {
    //if (!asociadoId) return;

    setAsociadoSelected(asociadoId != null && asociadoId > 0);
  }, [asociadoId]);

  useEffect(() => {
    //if (!asociadoId) return;
    /*
    Se debe poner por default seleccionado:
        id 1 Metodo de Pago: Plazos quincenales --- Forma de Pago: 2 Transferencia
    La relacion para las demas combinaciones:
        4 Metodo de Pago: Contado Efectivo --- Forma de Pago: 1 Efectivo
        5 Metodo de Pago: Contado Mercado Pago --- Forma de Pago: 3 Mercado Pago
        3 Metodo de Pago: Contado Sitio --- Forma de Pago: 4 Aplazo
        2 Metodo de Pago: Contado Terminal --- Forma de Pago: 3 Mercado Pago
                                                        5- PAYPAL
*/

    const formaDePagoId = preloadFormaPago(metodoDePagoId);
    formik.setFieldValue("formaDePagoId", formaDePagoId);
  }, [metodoDePagoId]);

  function preloadFormaPago(metodoDePagoId) {
    let formaDePagoId = -1;
    if (METODO_DE_PAGOS.PLAZOS_QUINCENALES_ID === metodoDePagoId) {
      formaDePagoId = FORMA_DE_PAGOS.TRANSFERENCIA_ID;
    } else if (METODO_DE_PAGOS.CONTADO_TERMINAL_ID === metodoDePagoId) {
      formaDePagoId = FORMA_DE_PAGOS.MERCADO_PAGO_ID;
    } else if (METODO_DE_PAGOS.CONTADO_SITIO_ID === metodoDePagoId) {
      formaDePagoId = FORMA_DE_PAGOS.APLAZO_ID;
    } else if (METODO_DE_PAGOS.CONTADO_EFECTIVO_ID === metodoDePagoId) {
      formaDePagoId = FORMA_DE_PAGOS.EFECTIVO_ID;
    } else if (METODO_DE_PAGOS.CONTADO_MERCADO_PAGO_ID === metodoDePagoId) {
      formaDePagoId = FORMA_DE_PAGOS.MERCADO_PAGO_ID;
    }

    /*setTimeout(() => {
      formik.setFieldValue("formaDePagoId", formaDePagoId);
    }, 2000);*/
    return formaDePagoId;
  }

  useImperativeHandle(ref, () => ({
    getValue: () => {
      return formik.values;
    },
    toggleModal: () => {
      formik?.resetForm();
      modalRef.current.click();
    },
  }));

  function addProduct(e) {
    const cantidad = Number.parseInt(formik.values.cantidad);

    if (Number.isNaN(cantidad)) {
      toast.error(
        "Error al pedir agregar producto. Cantidad debe de contener solo numeros",
      );
      return;
    }

    let item = null;
    const itemAgregadoIndex = productosAgregados.findIndex(
      (item) => item.id === formik.values.productId,
    );
    if (itemAgregadoIndex === -1) {
      item = productos.find((item) => item.id === formik.values.productId);
      if (item == null) {
        toast.error("Error al pedir agregar producto.");
        return;
      }
    } else {
      item = productosAgregados[itemAgregadoIndex];
    }

    item.maxCantidad = item.cantidad;
    item.cantidad = cantidad;

    /*

    */
    let precio = item.precioVenta;

    if (item.kind === "paq") {
      const sums = item.productos.reduce((accumulator, productoGeneral) => {
        const precio = productoGeneral.precio;
        return accumulator + precio * productoGeneral.cantidad;
      }, 0);
      precio = sums;
    }

    item.precio = precio;

    item.subTotal = item.cantidad * item.precio;
    item.total = item.subTotal;

    let newProductosAgregados = [...productosAgregados];
    if (itemAgregadoIndex === -1) {
      newProductosAgregados.push(item);

      //limpiar
      /// glow si ya existe
      newProductosAgregados = newProductosAgregados.map((producto) => {
        producto.canPulse = false;
        return producto;
      });
    } else {
      //ya existe mostrar visualmente

      /// glow si ya existe
      newProductosAgregados = newProductosAgregados.map((producto) => {
        producto.canPulse = false;
        if (producto === item) {
          producto.canPulse = true;
        }
        return producto;
      });
    }

    setProductosAgregados(newProductosAgregados);

    formik.setFieldValue("ordenVentaDetalles", newProductosAgregados);

    calculateTotals(newProductosAgregados);

    /*
      const id = e == null ? 0 : parseInt(e.id);
                            formik.setFieldValue("productId", id);

                            formik.setFieldValue("productSelected", e);*/

    formik.setFieldValue("cantidad", 0); //formik.values.cantidad);
    formik.setFieldValue("productId", "");
    formik.setFieldValue("productSelected", null);

    refAutocompleteProducto.current.clearInput();
  }

  function removeProduct(index) {
    if (index === -1) {
      return;
    }

    let newProductosAgregados = [...productosAgregados];
    newProductosAgregados[index].bonificaciones = [];

    newProductosAgregados[index].descuento = 0;
    newProductosAgregados[index].promocionId = null;

    /*
      currentValue.descuento = descuento;
      currentValue.total = currentValue.subTotal - descuento;
      currentValue.promocionId = promocion.id;
      */
    newProductosAgregados.splice(index, 1);

    formik.setFieldValue("ordenVentaDetalles", newProductosAgregados);

    setProductosAgregados(newProductosAgregados);

    calculateTotals(newProductosAgregados);
  }

  function updateProduct(index, newCantidad) {
    if (index === -1) {
      return;
    }

    let producto = productosAgregados[index];

    //
    const item = productos.find((item) => item.id === producto.id);
    if (item != null) {
      //  toast.error("Error al pedir agregar producto.");

      if (item.maxCantidad < newCantidad) {
        let newErrorCantidad =
          producto.id > 0 && item.cantidad < newCantidad
            ? "No existe cantidad suficiente en inventario"
            : "";
        //  setErrorCantidad(newErrorCantidad);
        toast.error(newErrorCantidad);

        return;
      }
    } else {
      return;
    }

    producto.cantidad = newCantidad;
    producto.subTotal = producto.cantidad * producto.precio;
    producto.total = producto.subTotal;

    let newProductosAgregados = [...productosAgregados];

    formik.setFieldValue("ordenVentaDetalles", newProductosAgregados);

    setProductosAgregados(newProductosAgregados);

    calculateTotals(newProductosAgregados);
  }

  const calculateTotals = (productosAgregados) => {
    const initialValue = 0;
    const sums = productosAgregados.reduce((accumulator, currentValue) => {
      /*
         item.precioVenta;
    item.subTotal = item.cantidad * item.precio;
    */
      return accumulator + currentValue.cantidad * currentValue.precio;
    }, initialValue);

    //item.total = item.cantidad * item.precio;
    const descuento = productosAgregados.reduce((accumulator, currentValue) => {
      currentValue.descuento = 0;
      currentValue.promocionId = null;

      console.log("---> XXX ");
      if (
        currentValue.bonificaciones == null ||
        currentValue.bonificaciones?.length === 0
      )
        return accumulator;

      const bonificacion = currentValue.bonificaciones[0];
      const { promocion, promoConfig } = bonificacion;
      const promocionDetalle = promocion.promocionDetalles[0];

      /**
       * Regalo en Compra
       */
      if (
        promocionDetalle.id !== PROMOCIONES_STATES.REGALO_EN_COMPRA.id &&
        sums < promocionDetalle.compraMinima
      ) {
        return accumulator;
      }

      let descuento =
        currentValue.subTotal * (promocionDetalle.descuento / 100);
      /**
       * VEnta Interna aplicar descuentoProducto de la pantalla por el personalizado del %
       */
      //if (promocion.id === PROMOCIONES_STATES.VENTA_INTERNA.id) {
      if (promocion.editar) {
        const promoConfig = bonificacion.promoConfig;
        //descuento = currentValue.subTotal * (promocion.descuentoPorcentaje / 100);
        //--descuento = promocion.descuentoTotal;
        // es absolutos nuevo total es con la cantidad ya aplicada
        /*descuento =
          currentValue.subTotal -
          promoConfig.nuevoTotal * currentValue.cantidad;*/
        descuento = currentValue.subTotal - promoConfig.nuevoTotal;

        //TEST
        //descuento = parseFloat(descuento.toFixed(2));
      }
      /*
        no pueden valer 0 lo gratis por el SAT tiene que valer 1c
        */
      if (promocionDetalle.descuento === 100) {
        descuento -= 0.01;
      }
      currentValue.descuento = descuento;
      currentValue.total = currentValue.subTotal - descuento;
      currentValue.promocionId = promocion.id;

      return accumulator + descuento;
    }, 0);

    setOrdenSubtotal(sums);
    setOrdenDescuento(descuento);

    const total = sums - descuento;
    setOrdenTotal(total);

    validateOrder();
  };

  useEffect(() => {
    validateOrder();
  }, [ordenTotal]);

  useUpdateEffect(() => {
    if (modalDataBonificacion == null) {
      return;
    }
    selectBonificacionRef.current.toggleModal();
  }, [modalDataBonificacion]);

  const validateOrder = () => {
    validateAsociadoCredito();
    validateAsociadoCongelado();
    validateOrderStatus();
  };

  const validateOrderStatus = () => {
    if (item?.estatuOrden == null) {
      setOrdenBlocked(false);
      return;
    }
    //completado 3
    setOrdenBlocked(ORDEN_VENTA_STATUS.EN_PROCESO.id !== item.estatuOrden.id);
  };

  const validateAsociadoCongelado = () => {
    if (asociadoIdRef.current === 0) {
      setAsociadoCongelado(false);
      return;
    }

    let asociado = asociados.find((item) => item.id === asociadoIdRef.current);
    if (asociado == null) {
      setAsociadoCongelado(false);
      return;
    }
    setAsociadoCongelado(asociado.info?.congelado ?? false);
  };

  const validateAsociadoCredito = () => {
    if (asociadoIdRef.current === 0) {
      setCreditoSuperado(false);
      return;
    }

    let asociado = asociados.find((item) => item.id === asociadoIdRef.current);

    if (asociado == null) {
      setCreditoSuperado(false);
      return;
    }

    const creditoDisponible = asociado.info?.creditoDisponible;

    const superado = ordenTotal > creditoDisponible;
    setCreditoSuperado(superado);
  };

  const clientFetch = async (asociadoId) => {
    if (asociadoId === 0) {
      setClientes([]);
      return;
    }
    const response = await api.asociadoClientes(asociadoId).catch((e) => {
      toast.error("Error al pedir asociados clientes.");
    });
    if (!response) return;

    const autoClientes = response.data.clientes.map((item) => {
      const text = buildNameWithId(item, item.numCliente);
      return { id: item.id, nombre: text };
    });

    setClientes(autoClientes);

    console.log(response.status);
  };

  function loadItem(newItem) {
    const isEmpty = newItem && Object.keys(newItem).length === 0;
    if (isEmpty) {
      return;
    }

    fetchData();

    //clientFetch(newItem.asociado.id);
    formik.setFieldValue("clienteId", newItem.cliente?.id);

    console.log("-->BOOM NV clienteNombre");

    //formik.setFieldValue("asociadoNombreCurp", "WRY GOOGOG");

    // precarga cliente
    setTimeout(async () => {
      if (newItem.cliente) {
        const clienteNombre = [
          newItem.cliente.numCliente,
          "-",
          newItem.cliente?.nombre,
          newItem.cliente?.apellidoPaterno,
          newItem.cliente?.apellidoMaterno,
        ].join(" ");
        formik.setFieldValue("asociadoNombreCurp", clienteNombre);

        // console.log("-->LOADITEM NV clienteNombre");
      }
    }, 100);
    console.log("-->LOADITEM NV");

    //formik.setFieldValue("asociadoNombreCurp", "WRY");

    refAutocompleteProducto.current.clearInputOnly();
    refAutocompleteAsociados.current.clearInputOnly();

    const ordenVentaDetalles = newItem.ordenVentaDetalles.map((item) => {
      let bonificacion = null;
      if (item.promocion != null) {
        bonificacion = {
          promocion: item.promocion,
          promoConfig: {
            descuentoPorcentaje: item.descuentoPorcentaje,
            nuevoTotal: item.total,
          },
        };
      }

      let producto = { ...item.producto };
      let paquete = {};
      let kind = "prod";
      if (item.paquete != null) {
        //obtener precioHistorial
        if (item.paquetePrecio) {
          item.paquete.productos.forEach((paqueteProducto) => {
            const findIndex = item.paquetePrecio.productosPrecios.findIndex(
              (pp) => pp.productoEnPaquete?.id === paqueteProducto.id,
            );
            if (findIndex === -1) return;

            paqueteProducto.precioHistorial =
              item.paquetePrecio.productosPrecios[findIndex].precioHistorial;
            /*paqueteProducto.precioHistorial =
              item.paquetePrecio.productosPrecios[findIndex].productoEnPaquete;*/
          });
        }

        kind = "paq";
        producto = {};
        paquete = { ...item.paquete };
      }

      return {
        id: item.productoId,
        cantidad: item.cantidad,
        precio: item.precio,
        total: item.total,
        subTotal: item.subTotal,
        descuento: item.descuento,
        //promocion: item.promocion,
        bonificaciones: bonificacion ? [bonificacion] : null,
        kind: kind,
        ...producto,
        ...paquete,
      };
    });

    setProductosAgregados(ordenVentaDetalles);

    calculateTotals(ordenVentaDetalles);
  }

  function loadClienteItem(item) {
    if (!permissions.canVerDetalle) return;

    console.log(createClientesRef);
    setModalData(item);
    setDefaultOnlyAsociadoId(formik.values.asociadoId);

    createClientesRef.current.toggleModal();
  }

  function loadBonoficacionItem(item) {
    if (!permissions.canVerDetalle) return;

    let asociado = asociados.find(
      (item) => item.id === formik.values.asociadoId,
    );
    let cliente = clientes.find((item) => item.id === formik.values.clienteId);

    let bonificacion = null;
    if (item.bonificaciones?.length > 0) {
      bonificacion = item.bonificaciones[0];
    }

    setModalDataBonificacion({
      producto: item,
      bonificacion,
      asociado,
      cliente,
    });
  }

  function onChangeBonoficacion(infos, bonificacion) {
    console.log("---onChangeBonoficacion");

    const foundIndex = productosAgregados.findIndex((currItem) => {
      return currItem === modalDataBonificacion.producto;
    });

    if (foundIndex < 0) return;

    /*
    precio unico debe de aplicarse a * cantidad porque desde la api ya viene aplicado a la cantidad
    */
    let newProductosAgregados = [...productosAgregados];
    if (bonificacion != null) {
      const newBonificacion = { ...bonificacion };
      newBonificacion.promoConfig.nuevoTotal *=
        newProductosAgregados[foundIndex].cantidad;

      newProductosAgregados[foundIndex].bonificaciones = [newBonificacion];
    } else {
      newProductosAgregados[foundIndex].bonificaciones = null;
    }

    setProductosAgregados(newProductosAgregados);

    setHasBonificaciones(true);

    calculateTotals(newProductosAgregados);
  }

  function validateAgregarProducto(
    cantidadRaw,
    productIdRaw,
    newProduct = null,
  ) {
    let cantidad = parseInt(cantidadRaw);
    let productoId = parseInt(productIdRaw);
    cantidad = isNaN(cantidad) ? 0 : cantidad;
    productoId = isNaN(productoId) ? 0 : productoId;

    let productoDisponible = newProduct?.option?.cantidad ?? 0;
    let isAvailable = productoDisponible >= cantidad;

    if (newProduct?.option.kind === "paq") {
      //  isAvailable = true;
      let re = 0;
      newProduct.option.productos.forEach((item) => {
        const disponibles = Math.floor(item.producto.cantidad / item.cantidad);
        if (re === 0 || disponibles < re) {
          re = disponibles;
        }
      });

      if (re < 0) {
        re = 0;
      }
      productoDisponible = re;

      isAvailable = productoDisponible >= cantidad;

      /*  isAvailable = true;
      newProduct.option.productos.forEach((item) => {
        isAvailable = item.producto.cantidad >= item.cantidad * cantidad;
        if (!isAvailable) return;
      });*/
    }

    formik.setFieldValue("productoDisponible", productoDisponible);

    setDisableAgregarProducto(cantidad <= 0 || productoId <= 0 || !isAvailable);

    setDisableSeleccionarCantidad(productoId <= 0 /*|| !isAvailable*/);
    //{...formik.getFieldProps("cantidad")}

    const item = productos.find((item) => item.id === formik.values.productId);
    if (item == null) {
      //  toast.error("Error al pedir agregar producto.");
      return;
    }

    let newErrorCantidad =
      productoId > 0 && item.cantidad < cantidad
        ? "No existe cantidad suficiente en inventario"
        : "";
    setErrorCantidad(newErrorCantidad);
  }

  function handleSubmit(event) {
    event.preventDefault();
  }
  //TODO checar invalidos
  function invalidateBonificacion() {
    const invalidState = productosAgregados.filter((producto, index, other) => {
      if (
        producto.bonificaciones == null ||
        producto.bonificaciones?.length === 0
      )
        return false;

      const bonificacion = producto.bonificaciones[0];
      const { promocion, promoConfig } = bonificacion;
      const promoDetalle = promocion.promocionDetalles[0];

      if (
        isAsociadoSeleccionado &&
        isClienteSeleccionado &&
        promoDetalle.exclusivoAsociado
      ) {
        return true;
      } else if (
        isAsociadoSeleccionado &&
        !isClienteSeleccionado &&
        !promoDetalle.exclusivoAsociado
      ) {
        return true;
      }
    });

    if (invalidState.length > 0) {
      errorModalBonificacionesRef.current.toggleModal();
    }
    console.log("--> INVALIDATE BONIFICACION: " + invalidState.length > 0);

    /*
      promos solo asociados, poniendo cliente preguntar si seguir
      */
    /*   let isEnabled =
          [1, 2, 3].includes(info.id) &&
          item?.asociado != null &&
          item?.cliente == null;

*/

    /* promo para asociado en especial, seleccionando cliente o cambiando asociado , preguntar */
    /*    if (
            [6].includes(info.id) &&
            item?.asociado != null &&
            item?.cliente == null &&
            info.promocionDetalles &&
            info.promocionDetalles.length > 0
          ) {
            const promocionDetalle = info.promocionDetalles[0];

            const paraAsociadoId = promocionDetalle.asociado?.id;
            isEnabled = item?.asociado.id === paraAsociadoId;
          }*/

    /*if (sums < promocionDetalle.compraMinima) {

      }*/

    //  })*/

    /*
      const descuento = productosAgregados.reduce((accumulator, currentValue) => {
      console.log("---> XXX ");
      if (
        currentValue.bonificaciones == null ||
        currentValue.bonificaciones?.length === 0
      )
        return accumulator;

      const promocion = currentValue.bonificaciones[0];
      const promocionDetalle = promocion.promocionDetalles[0];

      if (sums < promocionDetalle.compraMinima) {
        return accumulator;
      }
*/

    /*      let isEnabled =
          [1, 2, 3].includes(info.id) &&
          item?.asociado != null &&
          item?.cliente == null;

        if (!isEnabled) {
          if (
            [6].includes(info.id) &&
            item?.asociado != null &&
            item?.cliente == null &&
            info.promocionDetalles &&
            info.promocionDetalles.length > 0
          ) {
            const promocionDetalle = info.promocionDetalles[0];

            const paraAsociadoId = promocionDetalle.asociado?.id;
            isEnabled = item?.asociado.id === paraAsociadoId;
          }
        }*/
  }

  async function addToAsociado(clientId, asociadoId) {
    const response = await api
      .updateClienteAgregarAsociado(clientId, {
        asociadoId: asociadoId,
      })
      .catch((e) => {
        toast.error("Error al pedir clientes.");
      });
    return response != null;
  }

  /*
  function me(e) {
    console.log(e);
  }*/

  const formattedSubtotal = Singleton.getInstance().format(ordenSubtotal);
  const formattedDescuento = Singleton.getInstance().format(ordenDescuento);
  const formattedTotal = Singleton.getInstance().format(ordenTotal);

  const isAsociadoSeleccionado = formik.values.asociadoId > 0;
  const isClienteSeleccionado = formik.values.clienteId > 0;

  console.log("--> CREATEORDEN Draw");
  const qtyTotal = productosAgregados.reduce(function (count, item, index) {
    count += item.cantidad;
    return count;
  }, 0);

  const disponiblesText =
    formik.values.productSelected != null
      ? `Disponible ${formik.values.productoDisponible}`
      : "Disponible - ";

  function clearInput() {
    //setShowClearButton(false);
    //dropDownClientesRef.current.value = "";
    dropDownClientesRef.current.focus();

    formik.setFieldValue("asociadoNombreCurp", "");

    /*const id =
                                              e == null
                                                ? 0
                                                : parseInt(cliente.id);*/
    formik.setFieldValue("clienteId", 0);

    //selectValue(null);
  }

  function updateClienteSelect(cliente, event) {
    formik.setFieldValue("asociadoNombreCurp", cliente.nombre);

    const id = event == null ? 0 : Number.parseInt(cliente.id);
    formik.setFieldValue("clienteId", id);

    dropDownClientesRef.current.click();
    dropDownClientesRef.current.blur();
    console.log("Input clicked--> OPTIO N CON CURP");
  }

  return (
    <>
      <CreateClient
        ref={createClientesRef}
        item={modalData}
        defaultAsociadoId={defaultOnlyAsociadoId}
        returnBack={(e) => {
          modalRef.current.click();
        }}
        reloadClientes={(infos) => {
          if (infos == null) {
            return;
          }

          const { newClienteId, nombre } = infos;

          /*  const item = asociados.find((item) => item.id === newAsociadoId);
      if (item == null) {
        toast.error("Error al pedir agregar producto.");
        return;
      }*/

          console.log("2");
          //formik.setFieldValue("asociadoId", newAsociadoId);
          // asociadoIdRef.current = newAsociadoId;
          // clientFetch(newAsociadoId);
          formik.setFieldValue("asociadoNombreCurp", nombre);

          formik.setFieldValue("clienteId", newClienteId);
        }}
      />
      <button
        ref={modalRef}
        type="button"
        className="btn btn-primary"
        data-bs-toggle="modal"
        data-bs-target="#staticBackdropCrearOrden"
        hidden
      >
        Abrir Crear Orden
      </button>

      <div
        className="modal fade modal-xl"
        id="staticBackdropCrearOrden"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-labelledby="staticBackdropCrearOrdenLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="staticBackdropLabel">
                {createMode ? "Crear" : "Editar"} Orden
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>

            <div
              className="modal-body"
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <form className="row g-3" onSubmit={handleSubmit}>
                <div className="form-control">
                  {creditoSuperado && (
                    <div className="alert alert-danger" role="alert">
                      El total de la orden de venta <b>supera</b> el credito
                      para el asociado.
                    </div>
                  )}
                  {asociadoCongelado && (
                    <div className="alert alert-danger" role="alert">
                      No se puede realizar una Orden de Venta a un Asociado que
                      se encuentra en Estatus Congelado
                      <span>
                        <img
                          alt=""
                          src={SVGImages.SNOWFLAKE}
                          style={{
                            width: "16px",
                            height: "16px",
                            marginLeft: "5px",
                          }}
                        />
                      </span>
                    </div>
                  )}
                  <h5>Información General</h5>

                  <div className="row mb-1">
                    <div className="mb-1align-self-start">
                      <label
                        htmlFor="exampleInputEmail1"
                        className="form-label"
                      >
                        Asociado
                      </label>
                      <AutocompleteGo
                        ref={refAutocompleteAsociados}
                        options={asociados}
                        placeholder="Buscar asociado..."
                        className={`form-select ${invalidClass(
                          formik.errors.asociadoId,
                        )}`}
                        value={formik.values.asociadoId}
                        onChange={(e) => {
                          //formik.setFieldValue("sucursal", e);
                          console.log(e);
                          const id = e == null ? 0 : Number.parseInt(e.id);
                          formik.setFieldValue("asociadoId", id);
                          asociadoIdRef.current = id;

                          setDisableCrearOrden(id === 0);
                          formik.setFieldValue("clienteId", 0);

                          validateOrder();

                          clientFetch(id);
                        }}
                        readOnly={!createMode}
                      >
                        <div className="valid-feedback">Looks good!</div>
                        <div className="invalid-feedback">
                          {formik.errors.asociadoId}
                        </div>
                      </AutocompleteGo>
                    </div>
                  </div>

                  {/*  <!-- The Input --> */}
                  <div className="row mb-1">
                    <div className="form-group">
                      <label htmlFor="inputBuscarCliente">Cliente</label>
                      <div className="row">
                        <div className="col-9 position-relative">
                          <input
                            ref={dropDownClientesRef}
                            type="text"
                            className="form-control"
                            id="inputBuscarCliente"
                            placeholder="Buscar por Nombre o CURP..."
                            data-bs-toggle="dropdown"
                            data-bs-auto-close="outside"
                            autoComplete="off"
                            {...formik.getFieldProps("asociadoNombreCurp")}
                            onChange={async (e) => {
                              const val = e.target.value;
                              formik.setFieldValue("asociadoNombreCurp", val);

                              setSearchTerm(e.target.value);
                            }}
                            disabled={!asociadoSelected && !ordenBlocked}
                          />
                          <span
                            onClick={(e) => {
                              clearInput();
                            }}
                            className={`form-control-clear glyphicon glyphicon-remove form-control-feedback me-3 ${
                              showClearButton ? "" : "hideButton"
                            }`}
                          >
                            <IoMdClose />
                          </span>

                          {/*<!-- The Floating Menu -->*/}
                          <ul
                            className="dropdown-menu w-100"
                            aria-labelledby="floatingMenuInput"
                          >
                            <li
                              className="btn-group d-flex justify-content-center"
                              role="group"
                            >
                              <div
                                className=" d-flex gap-3"
                                aria-label="Horizontal filter row"
                                style={{}}
                              >
                                {/*  <input
                            type="checkbox"
                            className="btn-check btn-sm"
                            id="filter1"
                            autoComplete="off"
                          />
                          <label
                            className="btn btn-outline-primary rounded-pill btn-sm"
                            htmlFor="filter1"
                            onClick={(e) => {
                              e.stopPropagation(); // Stops bubbling up
                              e.preventDefault(); // Stops default browser behavior
                              console.log("Input clicked");
                            }}
                          >
                            Todo
                          </label>*/}

                                <input
                                  type="checkbox"
                                  className="btn-check btn-sm"
                                  id="filter2"
                                  autoComplete="off"
                                  checked={showClientesConNombre}
                                  onClick={(e) => {
                                    e.stopPropagation(); // Stops bubbling up
                                    //e.preventDefault(); // Stops default browser behavior
                                    console.log(
                                      "Input clicked: " + showClientesConNombre,
                                    );

                                    setShowClientesConNombre(
                                      e.currentTarget.checked,
                                    );
                                  }}
                                />
                                <label
                                  className="btn btn-outline-success rounded-pill btn-sm"
                                  htmlFor="filter2"
                                >
                                  Clientes con Nombre (
                                  {asociadoConNombre.length})
                                </label>

                                <input
                                  type="checkbox"
                                  className="btn-check btn-sm"
                                  id="filter3"
                                  autoComplete="off"
                                  checked={showClientesConCurp}
                                  onClick={(e) => {
                                    e.stopPropagation(); // Stops bubbling up
                                    // e.preventDefault(); // Stops default browser behavior
                                    console.log("Input clicked");

                                    setShowClientesConCurp(
                                      e.currentTarget.checked,
                                    );
                                  }}
                                />
                                <label
                                  className="btn btn-outline-warning rounded-pill btn-sm"
                                  htmlFor="filter3"
                                >
                                  Clientes con CURP ({asociadoConCURP.length})
                                </label>

                                <input
                                  type="checkbox"
                                  className="btn-check btn-sm"
                                  id="filter4"
                                  autoComplete="off"
                                  checked={showClientesConCurpEnOtro}
                                  onClick={(e) => {
                                    e.stopPropagation(); // Stops bubbling up
                                    //  e.preventDefault(); // Stops default browser behavior
                                    console.log("Input clicked");

                                    setShowClientesConCurpEnOtro(
                                      e.currentTarget.checked,
                                    );
                                  }}
                                />
                                <label
                                  className="btn btn-outline-primary rounded-pill btn-sm"
                                  htmlFor="filter4"
                                >
                                  Clientes con CURP en Otro Asociado (
                                  {asociadoConCURPEnOtro.length})
                                </label>
                              </div>
                            </li>

                            <li className="px-5">
                              <div className="d-flex flex-column gap-4 mt-3">
                                {showClientesConNombre && (
                                  <section aria-labelledby="section1-heading">
                                    <h5
                                      id="section1-heading"
                                      className="text-secondary mb-2 fw-semibold font-create-seccion"
                                    >
                                      Clientes con Nombre (
                                      {asociadoConNombre.length})
                                    </h5>
                                    <div
                                      className="list-group overflow-y-auto overflow-x-hidden"
                                      style={{ maxHeight: "200px" }}
                                    >
                                      {asociadoConNombre.map((cliente) => {
                                        return (
                                          <a
                                            key={cliente.id}
                                            href="#"
                                            className="list-group-item list-group-item-action d-flex justify-content-between align-items-center font-create-seccion-label"
                                            role="button"
                                            tabIndex={0}
                                            onClick={(e) => {
                                              /*  e.stopPropagation(); // Stops bubbling up
                              e.preventDefault(); // Stops default browser behavior
                            */

                                              formik.setFieldValue(
                                                "asociadoNombreCurp",
                                                cliente.nombre,
                                              );

                                              const id =
                                                e == null
                                                  ? 0
                                                  : parseInt(cliente.id);
                                              formik.setFieldValue(
                                                "clienteId",
                                                id,
                                              );

                                              dropDownClientesRef.current.click();
                                              dropDownClientesRef.current.blur();

                                              console.log(
                                                "Input clicked--> OPTIO N",
                                              );

                                              //setShowClientesConCurp(e.currentTarget.checked);
                                            }}
                                          >
                                            {cliente.nombre}
                                            <i className="bi bi-chevron-right text-muted"></i>
                                          </a>
                                        );
                                      })}
                                    </div>
                                  </section>
                                )}

                                {showClientesConCurp && (
                                  <section aria-labelledby="section2-heading">
                                    <h5
                                      id="section2-heading"
                                      className="text-secondary mb-2 fw-semibold font-create-seccion"
                                    >
                                      Clientes con CURP (
                                      {asociadoConCURP.length})
                                    </h5>
                                    <div
                                      className="list-group overflow-y-auto overflow-x-hidden"
                                      style={{ maxHeight: "200px" }}
                                    >
                                      {asociadoConCURP.map((cliente) => {
                                        return (
                                          <div
                                            key={cliente.id}
                                            className="list-group-item d-flex justify-content-between align-items-center font-create-seccion-label"
                                            role="button"
                                            tabIndex={0}
                                            onClick={(e) => {
                                              /*  e.stopPropagation(); // Stops bubbling up
                              e.preventDefault(); // Stops default browser behavior
                            */

                                              updateClienteSelect(cliente, e);

                                              //setShowClientesConCurp(e.currentTarget.checked);
                                            }}
                                          >
                                            <div>
                                              <h6 className="mb-0 font-create-seccion-label">
                                                {cliente.nombre}
                                              </h6>
                                              <small className="text-muted font-create-seccion-label-detail">
                                                {cliente.curp}
                                              </small>
                                            </div>
                                            <i className="bi bi-chevron-right text-muted"></i>
                                          </div>
                                        );
                                      })}
                                    </div>
                                  </section>
                                )}

                                {showClientesConCurpEnOtro && (
                                  <section aria-labelledby="section2-heading">
                                    <h5
                                      id="section2-heading"
                                      className="text-secondary mb-2 fw-semibold font-create-seccion"
                                    >
                                      Clientes con CURP En Otro Asociado (
                                      {asociadoConCURPEnOtro.length})
                                    </h5>
                                    <div
                                      className="list-group overflow-y-auto overflow-x-hidden"
                                      style={{ maxHeight: "200px" }}
                                    >
                                      {asociadoConCURPEnOtro.map((cliente) => {
                                        return (
                                          <div
                                            key={cliente.id}
                                            className="list-group-item d-flex justify-content-between align-items-center"
                                          >
                                            <div>
                                              <h6 className="mb-0 font-create-seccion-label ">
                                                {cliente.nombre}
                                              </h6>
                                              <small className="text-muted font-create-seccion-label-detail">
                                                {cliente.curp}
                                              </small>
                                            </div>
                                            <div className="form-check form-switch">
                                              <button
                                                type="button"
                                                className="btn btn-outline-success btn-sm"
                                                onClick={async (e) => {
                                                  e.stopPropagation(); // Stops bubbling up
                                                  e.preventDefault(); // Stops default browser behavior
                                                  console.log("Input clicked");
                                                  if (
                                                    await addToAsociado(
                                                      cliente.id,
                                                      asociadoIdRef.current,
                                                    )
                                                  ) {
                                                    updateClienteSelect(
                                                      cliente,
                                                      e,
                                                    );

                                                    return;
                                                  }
                                                  toast.error(
                                                    "Error al agregar a asociado.",
                                                  );
                                                }}
                                              >
                                                Agregar a Este Asociado
                                              </button>
                                            </div>
                                          </div>
                                        );
                                      })}
                                      {/*<div className="list-group-item d-flex justify-content-between align-items-center">
                                <div>
                                  <h6 className="mb-0">Asu</h6>
                                  <small className="text-muted">FER32555557</small>
                                </div>
                                <div className="form-check form-switch">
                                  <button
                                    type="button"
                                    className="btn btn-outline-success"
                                  >
                                    Agregar a Este Asociado
                                  </button>
                                </div>
                              </div>*/}
                                    </div>
                                  </section>
                                )}

                                {/*  <section aria-labelledby="section3-heading">
                            <h5
                              id="section3-heading"
                              className="text-secondary mb-2 fw-semibold font-create-seccion"
                            >
                              Danger Zone
                            </h5>
                            <div className="list-group">
                              <button
                                type="button"
                                className="list-group-item list-group-item-action list-group-item-danger"
                              >
                                Deactivate Account
                              </button>
                            </div>
                          </section> */}
                              </div>
                            </li>
                          </ul>
                        </div>

                        <div className="col">
                          <button
                            className="btn btn-primary"
                            type="button"
                            id="button-addon2"
                            onClick={(event) => loadClienteItem({})}
                            disabled={!asociadoSelected && !ordenBlocked}
                          >
                            Crear cliente
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row mb-1">
                    <div className="col">
                      <label
                        htmlFor="exampleInputEmail1"
                        className="form-label"
                      >
                        Metodo De Pago
                      </label>
                      <select
                        className={`form-control ${invalidClass(
                          formik.errors.metodoDePagoId,
                        )}`}
                        id="inputGroupSelect01"
                        {...formik.getFieldProps("metodoDePagoId")}
                        onChange={(e) => {
                          formik.setFieldValue(
                            "metodoDePagoId",
                            Number.parseInt(e.target.value),
                          );
                        }}
                        disabled={ordenBlocked}
                      >
                        <option value="-1" selected disabled hidden>
                          Selecciona un Metodo De Pago...
                        </option>
                        {metodosDePago.map((item) => {
                          return (
                            <option key={item.id} value={item.id}>
                              {item.nombre}
                            </option>
                          );
                        })}
                      </select>
                      <div className="valid-feedback"></div>
                      <div className="invalid-feedback">
                        {formik.errors.metodoDePagoId}
                      </div>
                    </div>
                    <div className="col">
                      <label
                        htmlFor="exampleInputEmail1"
                        className="form-label"
                      >
                        Forma De Pago
                      </label>
                      <select
                        className={`form-control ${invalidClass(
                          formik.errors.formaDePagoId,
                        )}`}
                        id="inputGroupSelect01"
                        {...formik.getFieldProps("formaDePagoId")}
                        onChange={(e) => {
                          formik.setFieldValue(
                            "formaDePagoId",
                            Number.parseInt(e.target.value),
                          );
                        }}
                        disabled={ordenBlocked}
                      >
                        <option value="-1" selected disabled hidden>
                          Selecciona una Forma De Pago...
                        </option>
                        {formasDePago.map((item) => {
                          return (
                            <option key={item.id} value={item.id}>
                              {item.nombre}
                            </option>
                          );
                        })}
                      </select>
                      <div className="valid-feedback"></div>
                      <div className="invalid-feedback">
                        {formik.errors.formaDePagoId}
                      </div>
                    </div>
                  </div>

                  <div className="row mb-1">
                    <div className="col">
                      <label
                        htmlFor="exampleInputEmail1"
                        className="form-label"
                      >
                        Tipo de Entrega
                      </label>
                      <select
                        className={`form-control ${invalidClass(
                          formik.errors.tipoEntregaId,
                        )}`}
                        id="inputGroupSelect01"
                        {...formik.getFieldProps("tipoEntregaId")}
                        onChange={(e) => {
                          formik.setFieldValue(
                            "tipoEntregaId",
                            Number.parseInt(e.target.value),
                          );
                        }}
                        disabled={ordenBlocked}
                      >
                        <option value="" selected disabled hidden>
                          Selecciona un Tipo de Entrega...
                        </option>
                        {roles.map((item) => {
                          return <option value={item.id}>{item.nombre}</option>;
                        })}
                      </select>
                    </div>
                    <div className="col align-content-center ">
                      <div className="form-check form-switch">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="flexSwitchCheckApartadoDefault"
                          {...formik.getFieldProps("apartado")}
                          checked={formik.values.apartado}
                          disabled={!createMode}
                        />
                        <span>
                          <label
                            className="form-check-label"
                            htmlFor="flexSwitchCheckApartadoDefault"
                          >
                            Apartado
                          </label>
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="separator" style={{ marginTop: "15px" }}>
                    <div className="mb-3">
                      <div className="row">
                        <div className="col">
                          <label
                            htmlFor="validationApellidoPaterno"
                            className="form-label"
                          >
                            Producto
                          </label>

                          <AutocompleteGo
                            ref={refAutocompleteProducto}
                            options={productos}
                            liveMode={true}
                            placeholder="Buscar Paquete por Nombre, Producto por Nombre, Codigo de Barras o SKU..."
                            className={`form-select ${invalidClass(
                              formik.errors.ordenVentaDetalles,
                            )}`}
                            onChange={(e) => {
                              //formik.setFieldValue("sucursal", e);
                              console.log("-->onChange create Orden");
                              const id = e == null ? 0 : parseInt(e.id);
                              if (id === 0) {
                                formik.setFieldValue("cantidad", 0);
                              }
                              formik.setFieldValue("productId", id);

                              formik.setFieldValue("productSelected", e);

                              //productoDisponible

                              validateAgregarProducto(
                                formik.values.cantidad,
                                id,
                                e,
                              );
                            }}
                            onInputChanged={(e) => {
                              //formik.setFieldValue("sucursal", e);

                              clearTimers();

                              addAlert(() => {
                                formik.setFieldValue("productoValue", e);
                                searchFetchData(e);
                              });
                            }}
                            readOnly={ordenBlocked}
                          >
                            <div className="valid-feedback">Looks good!</div>
                            <div
                              className="invalid-feedback"
                              style={{ display: "flex" }}
                            >
                              {errorCantidad}
                            </div>
                          </AutocompleteGo>
                        </div>
                        <div className="col-2">
                          <label
                            htmlFor="exampleInputEmail1"
                            className="form-label"
                          >
                            Cantidad
                          </label>
                          <input
                            type="number"
                            min="0"
                            max="20"
                            className={`form-control ${invalidClass(
                              errorCantidad,
                            )}`}
                            style={{ textAlign: "center" }}
                            id="validationName"
                            aria-describedby="emailHelp"
                            value={formik.values.cantidad}
                            onChange={(e) => {
                              formik.setFieldValue(
                                "cantidad",
                                e.currentTarget.value,
                              );
                              //{...formik.getFieldProps("cantidad")}

                              validateAgregarProducto(
                                e.currentTarget.value,
                                formik.values.productId,
                                formik.values.productSelected,
                              );
                            }}
                            disabled={disableSeleccionarCantidad | ordenBlocked}
                          />
                          <div
                            className="valid-feedback"
                            style={{ display: "flex" }}
                          >
                            {disponiblesText}
                          </div>
                        </div>
                        <div
                          className="col-3"
                          style={{ alignContent: "center" }}
                        >
                          <button
                            className="btn btn-warning"
                            type="button"
                            id="button-addon2"
                            disabled={disableAgregarProducto | ordenBlocked}
                            onClick={(event) => addProduct(event, item)}
                          >
                            Agregar producto
                          </button>
                        </div>
                      </div>
                      <div className="row ">
                        <div className="valid-feedback"></div>
                      </div>
                      <div className="row">
                        <div className="container">
                          <div
                            className="separator"
                            style={{ marginTop: "15px" }}
                          >
                            <table className="table caption-top">
                              <caption>Lista de productos</caption>
                              <thead>
                                <tr>
                                  <th scope="col">Nombre</th>
                                  <th scope="col">Marca</th>
                                  <th
                                    scope="col"
                                    style={{
                                      width: "100px",
                                      textAlign: "center",
                                    }}
                                  >
                                    Precio
                                  </th>
                                  <th
                                    scope="col"
                                    style={{
                                      width: "100px",
                                      textAlign: "center",
                                    }}
                                  >
                                    Cantidad
                                  </th>
                                  <th
                                    scope="col"
                                    style={{
                                      width: "100px",
                                      textAlign: "center",
                                    }}
                                  >
                                    Total
                                  </th>
                                  <th
                                    scope="col"
                                    style={{
                                      width: "100px",
                                      textAlign: "center",
                                    }}
                                    className="no-sort"
                                  >
                                    Acciones
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {productosAgregados.map((item, index) => {
                                  /*  const nombre = item.nombre;
                                  const marca = item.marca?.nombre ?? "";

                                  const precio = Singleton.getInstance().format(
                                    item.precio,
                                  );
                                  const maxCantidad = item.maxCantidad;
                                  const cantidad = item.cantidad;
                                  const subTotal =
                                    Singleton.getInstance().format(
                                      item.subTotal,
                                    );

                                  const canPulse = item.canPulse
                                    ? "pulse-glow"
                                    : "";*/

                                  const isPaquete = item.kind === "paq";
                                  const isProducto = item.kind === "prod";

                                  return (
                                    <>
                                      {isProducto && (
                                        <ProductoCard
                                          item={item}
                                          index={index}
                                          ordenBlocked={ordenBlocked}
                                          loadBonificacion={
                                            loadBonoficacionItem
                                          }
                                          updateProduct={updateProduct}
                                          removeProduct={removeProduct}
                                        />
                                      )}
                                      {isPaquete && (
                                        <PaqueteCard
                                          item={item}
                                          index={index}
                                          ordenBlocked={ordenBlocked}
                                          loadBonificacion={
                                            loadBonoficacionItem
                                          }
                                          updateProduct={updateProduct}
                                          removeProduct={removeProduct}
                                        />
                                      )}
                                    </>
                                  );
                                })}

                                <tr>
                                  <td
                                    colSpan="3"
                                    style={{
                                      textAlign: "right",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    Cantidad Total :
                                  </td>
                                  <td
                                    style={{
                                      width: "100px",
                                      textAlign: "center",
                                    }}
                                  >
                                    {qtyTotal}
                                  </td>
                                  <td></td>
                                </tr>
                              </tbody>
                            </table>

                            <div className="valid-feedback"></div>
                            <div className="invalid-feedback">
                              {formik.errors.productosCantidad}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="form-control">
                  <h5>Sumario</h5>
                  <div className="row">
                    <table className="table caption-top">
                      <thead>
                        <tr>
                          <th scope="col"></th>
                          <th scope="col"></th>
                          <th scope="col"></th>
                          <th scope="col"></th>
                          <th scope="col"></th>
                          <th
                            scope="col"
                            style={{ width: "100px", textAlign: "center" }}
                          ></th>
                          <th
                            scope="col"
                            style={{ width: "100px", textAlign: "center" }}
                          ></th>
                          <th
                            scope="col"
                            style={{ width: "100px", textAlign: "center" }}
                            className="no-sort"
                          ></th>
                        </tr>
                      </thead>

                      <tbody>
                        <tr>
                          <td colSpan={6} style={{ textAlign: "right" }}>
                            SubTotal :
                          </td>
                          <td style={{}}>{formattedSubtotal}</td>
                        </tr>
                        {hasBonificaciones && (
                          <tr>
                            <td colSpan={6} style={{ textAlign: "right" }}>
                              Bonificación :
                            </td>
                            <td>{formattedDescuento}</td>
                          </tr>
                        )}
                        {/*<tr>
                          <th scope="row">Shipping Cost :</th>
                          <td>$126.20</td>
                        </tr>*/}
                        <tr></tr>
                        <tr
                          style={{
                            borderTopWidth: "2px",
                            borderStyle: "dashed",
                            borderTopColor: "black",
                          }}
                        >
                          <td colSpan={6} style={{ textAlign: "right" }}>
                            Total :
                          </td>
                          <td style={{}}>{formattedTotal}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    data-bs-dismiss="modal"
                    ref={buttonCancelModalRef}
                  >
                    Cancelar
                  </button>
                  {
                    <LoadingButton
                      style={{ height: "38px" }}
                      onClick={(e) => {
                        formik.handleSubmit();
                      }}
                      text={"Guardar"}
                      loadingText={"Guardando..."}
                      isLoading={isLoading}
                      isDisable={
                        creditoSuperado || asociadoCongelado || ordenBlocked
                      }
                    />
                  }
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <SelectBonificacion
        ref={selectBonificacionRef}
        item={modalDataBonificacion}
        returnToModalId="staticBackdropCrearOrden"
        isAsociadoSeleccionado={isAsociadoSeleccionado}
        isClienteSeleccionado={isClienteSeleccionado}
        onChange={onChangeBonoficacion}
      />

      <ErrorModal
        ref={errorModalRef}
        returnToModalId="staticBackdropCrearOrden"
        infoTitle={`Guardar Orden`}
        infoText={`Para crear una Orden de Venta se requiere al menos la
                      cantidad de $20.00`}
      />

      <ErrorModal
        ref={errorModalBonificacionesRef}
        returnToModalId="staticBackdropCrearOrden"
        infoTitle={`Bonificaciones`}
        infoText={`Algunas Bonificaciones no cumplen con las condiciones para ser aplicadas`}
        customId={`boni`}
      />
    </>
  );
});

export default CreateOrdenVenta;
